module.exports = __webpack_public_path__ + "static/media/coming_soon.55b2eb05.png";